<template>
  <v-card elevation="4" class="dashboard-card rounded-xl pa-5 fill-height">
    <div class="d-flex justify-space-between align-center mb-3">
      <div class="dashboard-section-title">{{ title }}</div>
      <v-btn text small color="primary" :to="viewAllTo">Ver todos</v-btn>
    </div>
    <div v-if="items.length" class="due-list">
      <router-link
        v-for="due in items"
        :key="`${due.producto}-${due.fecha}`"
        :to="due.to"
        class="due-item"
      >
        <v-avatar :color="due.bg" size="34" class="mr-3">
          <v-icon :color="due.color" size="20">{{ due.icon }}</v-icon>
        </v-avatar>
        <div class="due-content">
          <strong>{{ due.producto }}</strong>
          <span>{{ due.fecha }} ({{ due.dias }} días)</span>
        </div>
        <div class="due-amount">{{ formatMonto(due.monto) }}</div>
        <v-icon small color="grey darken-1">mdi-chevron-right</v-icon>
      </router-link>
    </div>
    <div v-else class="empty-due-state">
      <div class="empty-due-illustration">
        <v-icon color="primary" size="48">mdi-calendar-month-outline</v-icon>
        <div class="empty-due-check">
          <v-icon color="primary" size="18">mdi-check</v-icon>
        </div>
      </div>
      <strong>{{ emptyTitle }}</strong>
      <span>{{ emptyText }}</span>
      <v-btn rounded outlined small color="primary" class="empty-due-action" :to="emptyActionTo">
        <v-icon left small>mdi-calculator-variant-outline</v-icon>
        {{ emptyActionText }}
      </v-btn>
    </div>
  </v-card>
</template>

<script>
import conv from "@/services/conversores";

export default {
  name: "UpcomingDueCard",
  props: {
    items: {
      type: Array,
      default: () => []
    },
    title: {
      type: String,
      default: "Próximos vencimientos"
    },
    viewAllTo: {
      type: [String, Object],
      default: () => ({ name: "productos", params: { product: "dap" } })
    },
    emptyTitle: {
      type: String,
      default: "No tiene Depósitos a Plazo vigentes."
    },
    emptyText: {
      type: String,
      default: "Cuando tengas depósitos próximos a vencer, aparecerán aquí automáticamente."
    },
    emptyActionText: {
      type: String,
      default: "Simular nuevo DAP"
    },
    emptyActionTo: {
      type: [String, Object],
      default: () => ({ name: "simulador-dap" })
    }
  },
  methods: {
    formatMonto(value) {
      return conv.formatMonto(value || 0, true);
    }
  }
};
</script>

<style scoped>
.dashboard-card {
  width: 100%;
  background: #ffffff !important;
  border: 1px solid rgba(31, 45, 53, 0.08);
  box-shadow: 0 10px 28px rgba(20, 52, 57, 0.1) !important;
}

.dashboard-section-title {
  color: #20333a;
  font-size: 1.05rem;
  font-weight: 700;
}

.due-item {
  align-items: center;
  border-bottom: 1px solid rgba(37, 108, 116, 0.1);
  color: #20333a;
  display: flex;
  padding: 9px 0;
  text-decoration: none;
}

.due-item:last-child {
  border-bottom: 0;
}

.due-content {
  display: flex;
  flex: 1;
  flex-direction: column;
  min-width: 0;
}

.due-content span {
  color: #5f7278;
  font-size: 0.78rem;
}

.due-amount {
  color: var(--v-primary-base);
  font-size: 0.86rem;
  font-weight: 800;
  margin-left: 10px;
  margin-right: 10px;
}

.empty-due-state {
  align-items: center;
  color: #60757b;
  display: flex;
  flex-direction: column;
  justify-content: center;
  min-height: 178px;
  padding: 10px 16px 14px;
  text-align: center;
}

.empty-due-illustration {
  align-items: center;
  background: linear-gradient(180deg, rgba(36, 202, 212, 0.11) 0%, rgba(36, 202, 212, 0.04) 100%);
  border-radius: 50%;
  display: flex;
  height: 72px;
  justify-content: center;
  margin-bottom: 8px;
  position: relative;
  width: 72px;
}

.empty-due-illustration > .v-icon {
  font-size: 34px !important;
}

.empty-due-check {
  align-items: center;
  background: #ffffff;
  border: 2px solid var(--v-primary-base);
  border-radius: 50%;
  bottom: 8px;
  box-shadow: 0 5px 12px rgba(20, 52, 57, 0.12);
  display: flex;
  height: 23px;
  justify-content: center;
  position: absolute;
  right: 9px;
  width: 23px;
}

.empty-due-state strong {
  color: #20333a;
  font-size: 0.92rem;
  font-weight: 800;
  margin-bottom: 5px;
}

.empty-due-state span {
  font-size: 0.78rem;
  line-height: 1.45;
  max-width: 360px;
}

.empty-due-action {
  font-size: 0.78rem;
  font-weight: 800;
  margin-top: 10px;
  text-transform: none;
}

@media (max-width: 599px) {
  .due-item {
    align-items: center;
    display: grid;
    gap: 0 12px;
    grid-template-columns: 34px minmax(0, 1fr) 18px;
  }

  .due-item > .v-avatar {
    grid-column: 1;
    grid-row: 1 / span 2;
    margin-right: 0 !important;
  }

  .due-content {
    grid-column: 2;
    grid-row: 1;
  }

  .due-amount {
    grid-column: 2;
    grid-row: 2;
    font-size: 0.85rem;
    margin-left: 0;
    margin-right: 0;
    margin-top: 4px;
    width: auto;
  }

  .due-item > .v-icon {
    grid-column: 3;
    grid-row: 1 / span 2;
    justify-self: end;
  }
}
</style>
